export const GET_INITIAL_TOKENS = 'GET_INITIAL_TOKENS';
export const GET_INITIAL_TOKENS_SUCCESS = `${GET_INITIAL_TOKENS}_SUCCESS`;
export const GET_INITIAL_TOKENS_FAIL = `${GET_INITIAL_TOKENS}_FAIL`;

const initialState = {
  isLoading: false,
  isLoaded: false,
  isError: false,
  error: null,
  data: null,
};

const templateReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_INITIAL_TOKENS:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        isError: false,
        data: null,
      };
    case GET_INITIAL_TOKENS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        isError: false,
        data: action.payload
      };
    case GET_INITIAL_TOKENS_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        isError: true,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};

export default templateReducer;
